import { Container } from 'components/ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useLooksContext from '../services/looksContext'
import { imgUrl } from 'utils/imgUrl'

const CategoryHeader = () => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const language = useMemo(
    () => i18n.language as 'uz' | 'ru' | 'en',
    [i18n.language]
  )
  const {
    state: { data }
  } = useLooksContext()
  return (
    <div
      className="category-header"
      style={{
        backgroundImage: `url(${imgUrl(data?.image)})`
      }}
    >
      <Container size="xxl" style={{ textAlign: 'center' }}>
        <h1 className="cormorant-title">{data?.name[language]}</h1>
        <p>
          {data?.products?.length || 0} {t('categories.available_products')}
        </p>
      </Container>
    </div>
  )
}

export default CategoryHeader
